import styled from "@emotion/styled";
import { SidebarNav } from "../SidebarNav";
import { usePageTitle } from "src/Common/hooks/usePageTitle";

interface Props {
  children: React.ReactNode;
}

export const Layout = ({ children }: Props) => {
  usePageTitle();
  return (
    <Container>
      <SidebarNav />
      <Content>{children}</Content>
      v.1
    </Container>
  );
};

const Container = styled.div({
  width: "100vw",
  height: "100vh",
  display: "grid",
  gridTemplateColumns: "40px 1fr",
});

const Content = styled.div({
  overflowY: "auto",
});
